import React from 'react';
import Styles from './ToyotaPrado.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';
import Hero from '../HeroForm/Hero';

const ToyotaPrado = () => {
  return (
    
     <div className={Styles.main_page}>
     <h2>Toyota Prado</h2>
     {/*Carousel*/}
     <div className={Styles.car_image}>
       <Carousel images={cars} />
     </div>
    <Hero selectedCar="Toyota Prado" /> 
   </div>
  );
}

export default ToyotaPrado;
